export const FIELD_TYPE_OPTIONS = [
  'Text',
  'Select',
  'Radio',
  'Number',
  'Custom',
  'Email',
  'Date',
  'Date Time',
  'MultiSelect',
  'Text Area',
  'Checkbox',
];

export const FIELD_ACCESS_OPTIONS = ['Both', 'User', 'Admin'];

export const STATUS_COLORS = {
  Open: '#FF0000',
  'Under Verification': '#FF6F00',
  Resolved: '#00D82F',
  Closed: '#006FFF',
};

export const STATUS_PRESET = {
  id: 'default-status',
  fieldKey: 'status',
  fieldLabel: 'Status',
  originalFieldName: 'Status',
  fieldType: 'Custom',
  required: true,
  fieldAccess: '',
  hideFor: [],
  dependsOn: '',
  options: ['Open', 'Closed', 'Resolved', 'Under Verification'],
  optionColors: { ...STATUS_COLORS },
  parentMappings: {},
  lockMode: 'options',
  isNew: false,
};

export const PRIORITIES_PRESET = {
  id: 'custom-priorities',
  fieldKey: 'priorities',
  fieldLabel: 'Priorities',
  originalFieldName: 'Priorities',
  fieldType: 'Dropdown',
  required: false,
  fieldAccess: '',
  hideFor: [],
  dependsOn: '',
  options: ['Urgent', 'High', 'Medium', 'Low'],
  parentMappings: {},
  lockMode: 'options',
  isNew: false,
};

export const STORE_ID_PRESET = {
  id: 'custom-store-id',
  fieldKey: 'storeId',
  fieldLabel: 'Store ID',
  originalFieldName: 'Store ID',
  fieldType: 'TextField',
  required: false,
  fieldAccess: '',
  hideFor: [],
  dependsOn: '',
  options: [],
  optionColors: {},
  parentMappings: {},
  lockMode: 'all',
  isNew: false,
};

export const CUSTOM_FIELD_LIBRARY = [
  {
    ...STATUS_PRESET,
    label: STATUS_PRESET.fieldLabel,
  },
  {
    ...STORE_ID_PRESET,
    label: STORE_ID_PRESET.fieldLabel,
  },
];

function normalizeFieldName(value) {
  return String(value || '').trim().toLowerCase();
}

export function isStatusField(field) {
  const key = normalizeFieldName(field?.fieldKey);
  const label = normalizeFieldName(field?.fieldLabel || field?.label);
  return key === 'status' || key === 'statuses' || label === 'status' || label === 'statuses';
}

export function isPrioritiesField(field) {
  const key = String(field?.fieldKey || '').toLowerCase();
  const label = String(field?.fieldLabel || field?.label || '').trim().toLowerCase();
  return key === 'priorities' || label === 'priorities';
}

export function isStoreIdField(field) {
  const key = String(field?.fieldKey || '').toLowerCase();
  const label = String(field?.fieldLabel || field?.label || '').trim().toLowerCase();
  return key === 'storeid' || label === 'store id';
}

export function isLockedStatusOption(option) {
  const key = String(option || '').trim().toLowerCase();
  return key === 'open' || key === 'closed';
}

export function isColorOptionsField(field) {
  return isStatusField(field);
}

export function applyPresetMeta(field) {
  if (isStatusField(field)) {
    const incomingLabel = String(field.fieldLabel || field.label || '').trim();
    const useDefaultLabel = !incomingLabel || incomingLabel.toLowerCase() === 'statuses';
    return {
      ...STATUS_PRESET,
      ...field,
      fieldKey: STATUS_PRESET.fieldKey,
      fieldLabel: useDefaultLabel ? STATUS_PRESET.fieldLabel : incomingLabel,
      originalFieldName: useDefaultLabel
        ? STATUS_PRESET.originalFieldName
        : (field.originalFieldName ?? incomingLabel),
      fieldType: STATUS_PRESET.fieldType,
      required: true,
      options: field.options?.length ? field.options : STATUS_PRESET.options,
      optionColors: { ...STATUS_PRESET.optionColors, ...field.optionColors },
      lockMode: 'options',
    };
  }
  if (isPrioritiesField(field)) {
    return {
      ...PRIORITIES_PRESET,
      ...field,
      fieldKey: field.fieldKey || PRIORITIES_PRESET.fieldKey,
      fieldType: PRIORITIES_PRESET.fieldType,
      options: field.options?.length ? field.options : PRIORITIES_PRESET.options,
      lockMode: 'options',
    };
  }
  if (isStoreIdField(field)) {
    return {
      ...STORE_ID_PRESET,
      ...field,
      fieldKey: field.fieldKey || STORE_ID_PRESET.fieldKey,
      fieldType: STORE_ID_PRESET.fieldType,
      lockMode: 'all',
    };
  }
  return field;
}

export function withDefaultStatus(fields = []) {
  const mapped = fields.map(applyPresetMeta);
  if (mapped.some(isStatusField)) return mapped;
  return [applyPresetMeta({ ...STATUS_PRESET }), ...mapped];
}
